import React from 'react'
import PropTypes from 'prop-types'
import { tz } from 'moment-timezone'

import Spinner from 'components/Spinner'
import Plot from 'pages/Device/ThermostatRthPanel/Chart/Plot'
import GoRthCycles from 'pages/Device/ThermostatRthPanel/GoRthCycles'
import { isNoDataAvailable } from 'pages/Device/ThermostatRthPanel/Chart/rthDataParser'

import useServerlessRth from 'hooks/useServerlessRth'

const propTypes = {
  rthDate: PropTypes.string.isRequired,
  startTime: PropTypes.string.isRequired,
  endTime: PropTypes.string.isRequired,
  timeZone: PropTypes.string.isRequired,
  dealerId: PropTypes.number,
  deviceId: PropTypes.string.isRequired,
  isZoomed: PropTypes.bool.isRequired,
  isControlHub: PropTypes.bool.isRequired,
  showFullScreen: PropTypes.bool.isRequired,
  refreshTimestamp: PropTypes.number.isRequired,
  zoomedCallback: PropTypes.func.isRequired,
  freezeMouseHover: PropTypes.bool.isRequired,
  freezeMouseHoverCallback: PropTypes.func.isRequired,
  updateSelectedLegendsCallback: PropTypes.func.isRequired,
  deviceType: PropTypes.string.isRequired
}

const defaultProps = {
  dealerId: null
}

const ServerlessRthChart = ({ rthDate, timeZone, dealerId, deviceId, isControlHub, isZoomed, zoomedCallback, showFullScreen, freezeMouseHover, freezeMouseHoverCallback, updateSelectedLegendsCallback, refreshTimestamp, deviceType }) => {
  const { rthData, isRTHDataLoaded } = useServerlessRth(dealerId, deviceId, rthDate, rthDate, timeZone, refreshTimestamp)
  const startTime = tz(`${rthDate}`, 'YYYY-MM-DD', timeZone).startOf('day').format('YYYY-MM-DD HH:mm:ss')
  const endTime = tz(`${rthDate}`, 'YYYY-MM-DD', timeZone).endOf('day').format('YYYY-MM-DD HH:mm:ss')

  if (!isRTHDataLoaded) {
    return <Spinner variant="page" />
  }

  const isNoData = isNoDataAvailable(rthData)

  return (
    <>
      <Plot
        deviceId={deviceId}
        rthData={rthData}
        isControlHub={isControlHub}
        startTime={startTime}
        endTime={endTime}
        timeZone={timeZone}
        isZoomed={isZoomed}
        zoomedCallback={zoomedCallback}
        showFullScreen={showFullScreen}
        freezeMouseHover={freezeMouseHover}
        updateSelectedLegendsCallback={updateSelectedLegendsCallback}
        freezeMouseHoverCallback={freezeMouseHoverCallback}
        chartDivId="plotly-go-rth-chart"
      />
      {!_.isEmpty(rthData?.stages) && <GoRthCycles stages={rthData.stages} />}
    </>
  )
}

ServerlessRthChart.propTypes = propTypes
ServerlessRthChart.defaultProps = defaultProps

export default ServerlessRthChart
